<template>
    <div class="checkbox-single">
        <label class="input-checkbox-single" @mouseenter="changeUncheckedImg" @mouseleave="changeUncheckedImg">
            <span class="msg" :class="{'disabled':isPropDisabled, 'left-msg': isLeftMsg}" v-if="isLeftMsg">{{msg}}</span>

            <img v-if="isChecked && isPropDisabled == false" class="checkbox-single-img" :src="checkedImg" alt="">
            <img v-else-if="isChecked && isPropDisabled" class="checkbox-single-img" :src="checkedDisabledImg" alt="">
            <img v-else-if="isChecked == false && isPropDisabled" class="checkbox-single-img" :src="uncheckedDisabledImg" alt="">
            <img v-else class="checkbox-single-img" :src="uncheckedImgSrc" alt="">
            <input type="radio" :value="val" v-model="checked" @change="onChange" :disabled="isPropDisabled"/>

            <span class="msg" :class="{'disabled':isPropDisabled}" v-if="!isLeftMsg">{{msg}}</span>
        </label>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
            uncheckedImgSrc: require('@/assets/img/component/widge/input/checkbox/checkbox_unchecked.svg'),
            checkedImg: require('@/assets/img/component/widge/input/checkbox/checkbox_checked.svg'),
            uncheckedImg: require('@/assets/img/component/widge/input/checkbox/checkbox_unchecked.svg'),
            checkedDisabledImg: require('@/assets/img/component/widge/input/checkbox/checkbox_checked_disabled.svg'),
            uncheckedDisabledImg: require('@/assets/img/component/widge/input/checkbox/checkbox_unchecked_disabled.svg'),
            uncheckedHoverImg: require('@/assets/img/component/widge/input/checkbox/checkbox_unchecked_hover.svg')
        }
    },
    props: {
        msg: String,
        val: '',
        value: '',
        isPropChecked: {
            default: false,
            type: Boolean
        },
        isPropDisabled: {
            default: false,
            type: Boolean
        },
        isLeftMsg: {
            default: false,
            type: Boolean
        },
    },
    watch: {
        isPropChecked: {
            handler: function (newValue, oldValue) {
                this.isChecked = newValue
            },
            immediate: true
        },
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = true;
            this.$emit('input', this.checkVal)
        },
        changeUncheckedImg: function () {
            if( event.type == 'mouseenter' ){
                this.uncheckedImgSrc = this.uncheckedHoverImg
            }else if( event.type == 'mouseleave' ){
                this.uncheckedImgSrc = this.uncheckedImg
            }
        }
    }
}
</script>
<style lang="scss"  >
    .input-checkbox-single{
        position: relative;
        display: inline-flex;
        align-items: center;
        cursor: pointer;

        .msg {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.57;
            letter-spacing: normal;
            color: rgba(0, 0, 0, 0.65);

            &.disabled {
                color: rgba(0, 0, 0, 0.25);
            }
            &.left-msg {
                margin-right: 4px;
            }
        }
        .checkbox-single-img{
            margin-right: 4px;
        }
        input{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/input/checkboxSingle.vue